import React from 'react'
import './GridModel.css'
import Button from '../Button/Button'
import Visibility from '@material-ui/icons/Visibility'

const GridModel = (props) => {
    return (
        <div className="row justify-content-center w-100 mt-2">
            <div className={["grid-row", props.className].join(' ')}>
                <div className="row h-0" dir="ltr" style={{ height: '20px' }}>
                    {props.hasEdit ?
                        <div className={[props.disableEdit !== null && props.disableEdit ? "disable-div" : "", "col-1 h-0"].join(" ")}>
                            <Button btnType="Edit" clicked={props.edit} >ویرایش</Button>
                        </div>
                        : ''}
                    {props.hasView ?
                        <div className="col-1 h-0 text-left mt-2">
                            <Visibility className="Edit" onClick={props.view} />
                        </div>
                        : ''}
                </div>
                <div className="row">
                    {props.model.map(m => {
                        return (
                            <div className="col-3 mt-2 grid-small-col">
                                {m.label}: {m.value} {m.unit}
                            </div>
                        )
                    })
                    }
                </div>
                <div className="row">
                    {props.extraBtns != null && props.extraBtns.length != 0 ?
                        props.extraBtns.map(btn => {
                            return (
                                { btn }
                            )
                        })
                        : ''}
                </div>
            </div>
        </div>
    )
}
export default GridModel